import {observer} from "mobx-react-lite";
import {useStores} from "../../../stores";
import {Autocomplete, Button, Checkbox, Grid, TextField} from "@mui/material";
import {DateRangePickerMui} from "../../../components/date-range-picker/DateRangePickerMui.tsx";
import {CheckBox, CheckBoxOutlineBlank, CloseOutlined} from "@mui/icons-material";
import {CurrencyComponent} from "../../../components/currency-component/CurrencyComponent";
import {BagAdvancedInsightsManager} from "../../../stores/managers/BagAdvancedInsightsManager";
import type {Country} from "../../../components/visualization/bubble-map/countries";
import {countriesToContinents, countryToContinent} from "../../../components/visualization/bubble-map/countries";
import dayjs from "dayjs";

export const ContractHeaderFiltersBar = observer(() => {
    const {bagStore} = useStores();
    return (
        <Grid container className="filter-container header-filter-container">
            <Grid container size={11}>
                <Grid size={3}>
                    <Autocomplete
                        className="adv-dashboard-filter-continent"
                        multiple
                        limitTags={1}
                        value={countriesToContinents(bagStore.advanced.filters.country as Country[] || [])}
                        options={bagStore.advanced.continentFilterData}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option ? option : '-'}
                        renderOption={(props, option) => {
                            const s = bagStore.advanced.filters.country && bagStore.advanced.filters.country.some((selectedCountry) => {
                                const continent = countryToContinent(selectedCountry as Country);
                                return continent === option;
                            });
                            return (
                                <li {...props} key={props.key}>
                                    <Checkbox
                                        icon={<CheckBoxOutlineBlank fontSize="small"/>}
                                        checkedIcon={<CheckBox fontSize="small"/>}
                                        style={{marginRight: 8}}
                                        checked={s}
                                    />
                                    <Grid container>
                                        <Grid size={6}>
                                            {option ? option : '-'}
                                        </Grid>
                                        <Grid size={6}>
                                            {/*TODO: No calculation in render thread*/}
                                            <CurrencyComponent
                                                v={BagAdvancedInsightsManager.calculateContinentSpend(bagStore.advanced.spendCountryData, option)}
                                                nDigits={3}/>
                                        </Grid>
                                    </Grid>
                                </li>
                            );
                        }}
                        onChange={(_, i) => {
                            const newCountries = i.flatMap((continent) => {
                                return bagStore.advanced.spendCountryData.filter((country) => {
                                    return countryToContinent(country.country) === continent;
                                }).map((country) => country.country);
                            });
                            bagStore.advanced.countryFilterChanged(newCountries);
                        }}
                        renderInput={(params) => (
                            <TextField {...params} label="Child suppliers"/>
                        )}
                    />
                </Grid>

                <Grid size={3}>
                    <Autocomplete
                        className="adv-dashboard-filter-continent"
                        multiple
                        limitTags={1}
                        value={countriesToContinents(bagStore.advanced.filters.country as Country[] || [])}
                        options={bagStore.advanced.continentFilterData}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option ? option : '-'}
                        renderOption={(props, option) => {
                            const s = bagStore.advanced.filters.country && bagStore.advanced.filters.country.some((selectedCountry) => {
                                const continent = countryToContinent(selectedCountry as Country);
                                return continent === option;
                            });
                            return (
                                <li {...props} key={props.key}>
                                    <Checkbox
                                        icon={<CheckBoxOutlineBlank fontSize="small"/>}
                                        checkedIcon={<CheckBox fontSize="small"/>}
                                        style={{marginRight: 8}}
                                        checked={s}
                                    />
                                    <Grid container>
                                        <Grid size={6}>
                                            {option ? option : '-'}
                                        </Grid>
                                        <Grid size={6}>
                                            {/*TODO: No calculation in render thread*/}
                                            <CurrencyComponent
                                                v={BagAdvancedInsightsManager.calculateContinentSpend(bagStore.advanced.spendCountryData, option)}
                                                nDigits={3}/>
                                        </Grid>
                                    </Grid>
                                </li>
                            );
                        }}
                        onChange={(_, i) => {
                            const newCountries = i.flatMap((continent) => {
                                return bagStore.advanced.spendCountryData.filter((country) => {
                                    return countryToContinent(country.country) === continent;
                                }).map((country) => country.country);
                            });
                            bagStore.advanced.countryFilterChanged(newCountries);
                        }}
                        renderInput={(params) => (
                            <TextField {...params} label="Business unit"/>
                        )}
                    />
                </Grid>

                <Grid size={3}>
                    <DateRangePickerMui
                        value={[dayjs('2022-01-01'), dayjs('2025-12-31')]}
                        onChange={(value) => {
                            const startDate = value[0]?.format('YYYY-MM-DD') || '';
                            const endDate = value[1]?.format('YYYY-MM-DD') || '';
                            console.log('startDate', startDate)
                            console.log('endDate', endDate)
                        }}
                    />
                </Grid>

                <Grid size={3}>
                    <Autocomplete
                        className="adv-dashboard-country-filter"
                        multiple
                        limitTags={1}
                        value={bagStore.advanced.filters.country || []}
                        options={bagStore.advanced.geoDataCountryStringArr}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option ? option : '-'}
                        sx={{width: 300}}
                        renderOption={(props, option, {selected}) =>
                            <li {...props} key={props.key}>
                                <Checkbox
                                    icon={<CheckBoxOutlineBlank fontSize="small"/>}
                                    checkedIcon={<CheckBox fontSize="small"/>}
                                    style={{marginRight: 8}}
                                    checked={selected}
                                />

                                <Grid container>
                                    <Grid size={2}>
                                        {/*TODO: Replace with https://github.com/davext/react-flag-cdn to potentially fix content policy issue*/}
                                        <img
                                            loading="lazy"
                                            width="20"
                                            srcSet={`https://flagcdn.com/w40/${option.toLowerCase()}.png 2x`}
                                            src={`https://flagcdn.com/w20/${option.toLowerCase()}.png`}
                                            alt=""
                                        />
                                    </Grid>
                                    <Grid style={{display: 'flex', alignItems: 'center'}} size={5}>
                                        {option ? option : '-'}
                                    </Grid>
                                    <Grid size={1}></Grid>
                                    <Grid style={{display: 'flex', alignItems: 'center'}} size={4}>
                                        <CurrencyComponent
                                            v={BagAdvancedInsightsManager.getCountrySpend(bagStore.advanced.spendCountryData, option)}
                                            nDigits={3}/>
                                    </Grid>
                                </Grid>
                            </li>
                        }
                        onChange={(_, value) => {
                            bagStore.advanced.countryFilterChangedNew(value);
                        }}
                        renderInput={(params) => (
                            <TextField {...params} label="Scope of contract"/>
                        )}
                    />
                </Grid>
            </Grid>

            <Grid style={{display: 'flex', justifyContent: 'flex-end'}} size={1}>
                <Button
                    variant="outlined"
                    style={{
                        width: '100%',
                        height: '4em',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    onClick={() => {
                        bagStore.advanced.reset()
                    }}>
                    <CloseOutlined/>
                </Button>
            </Grid>
        </Grid>
    );
})
